import {
  useIsClient
} from "./chunk-ATCO73JM.mjs";

// src/components/Suspense.tsx
import { Suspense as ReactSuspense } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
function Suspense({ children, clientOnly, fallback }) {
  const isClient = useIsClient();
  if (clientOnly && !isClient) {
    return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  }
  return /* @__PURE__ */ jsx(ReactSuspense, { fallback, children });
}

export {
  Suspense
};
